export default __webpack_public_path__ + "static/media/no-data-cuate.0205075b.svg";